import { jsx as _jsx } from "react/jsx-runtime";
import styles from './sidebar-footer.css';
export function SidebarFooter(props) {
    const { children } = props;
    return _jsx("div", { className: styles.footer, children: children });
}
